import { render, staticRenderFns } from "./Checkers.vue?vue&type=template&id=9cb48430"
import script from "./Checkers.vue?vue&type=script&lang=js"
export * from "./Checkers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports